export default __webpack_public_path__ + "static/media/slider.50d17683.png";